$(function() {
    $('.nav-item li a').on('click', function(){ 
        var pageId = $(this).attr('data-page');
        $('html, body').animate({ scrollTop: $('#'+pageId).offset().top - 80 }, 600); 
    });    
}); 

$(window).scroll(function() {
	var scrollDistance = $(window).scrollTop();
	// Assign active class to nav links while scolling
	$('.page-scroll').each(function(i) {
		if ($(this).position().top <= scrollDistance) {
			$('.nav-item li a.active').removeClass('active');
			$('.nav-item li a').eq(i).addClass('active');
		} 
	});
}).scroll();